import React from 'react'
import { Breadcrumb as AntdBreadcrumb, BreadcrumbProps } from 'antd'
import { RightOutlined } from '@ant-design/icons'
export const Breadcrumb: React.FC<BreadcrumbProps> = props => (
  <AntdBreadcrumb
    separator={<RightOutlined style={{ fontSize: '12px' }} />}
    {...props}
  />
)
